import { useContext, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { PlanningService } from "../../../core/_request";
import { HttpStatusCode } from "axios";
import { DatePicker, Dropdown, Radio, Segmented } from "antd";
import { MaterialConstant } from "../../../../materials/core/_constant";
import style from "./style.module.scss";
import { MaterialTransportAndLiftingForm } from "./MaterialTransportAndLiftingForm";
import { MaterialArmingForm } from "./MaterialArmingForm";
import { MaterialRequestContext } from "../../../core/_context";
import Spinner from "../../../../../common/components/Spinner/Spinner";
import dayjs from "dayjs";
import { OperationContext } from "../CreateOperation";

type PostDataTypeItem = {
  material: string;
  "@id"?: string;
};

type PropsType = {
  onClose: () => void;
};
const allKeys = [
  "materialsBargeCOMAMA",
  "materialsBargeSEMS",
  "materialsCraneCOMAMA",
  "materialsCraneSEMS",
  "materialsLiftingCOMAMA",
  "materialsLiftingSEMS",
  "materialsMachineCOMAMA",
  "materialsMachineSEMS",
  "materialsTugboatCOMAMA",
  "materialsTugboatSEMS",
];

export const MaterialRequestForm = ({ onClose }: PropsType) => {
  const { id } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();
  const { filter, setFilter } = useContext(OperationContext);
  const [isDisableForm, setIsDisableForm] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [materials, setMaterials] = useState<any>();
  const [selectedMaterials, setSelectedMaterials] = useState<Array<any>>([]);
  const typeFromUrl = searchParams.get("type")?.toUpperCase();
  const initialType =
    typeFromUrl === MaterialConstant.AREMING_ID
      ? MaterialConstant.AREMING_ID
      : MaterialConstant.TRANSPORT_AND_LIFTING_ID;

  const [selectedTransportType, setSelectedTransportType] =
    useState<string>(initialType);

  useEffect(() => {
    const label = MaterialConstant.MATERIAL_TYPE_OPTIONS.find(
      (opt) => opt.value === selectedTransportType
    )?.label;
    setSelectedLabel(label);
  }, [selectedTransportType]);

  useEffect(() => {
    if (filter && filter?.teamsCreatedAt) {
      const isFilterDateIsNow = dayjs(filter?.teamsCreatedAt).isSame(
        dayjs(),
        "date"
      );
      setIsDisableForm(!isFilterDateIsNow);
    }
  }, [filter]);

  useEffect(() => {
    id && getMaterials(id, { materialsCreatedAt: filter?.teamsCreatedAt });
  }, [id, filter]);

  useEffect(() => {
    setFilter((prev: any) => ({
      ...prev,
      teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
    }));
  }, []);

  useEffect(() => {
    let data: Array<string> = [];

    allKeys?.forEach((item: any) => {
      materials?.[item]?.forEach((elem: any) => {
        data = [...data, elem?.material?.value];
      });
    });
    setSelectedMaterials(data);
  }, [materials]);

  const getMaterials = async (id: string, params: any) => {
    try {
      setIsLoading(true);
      const res = await PlanningService.getMaterialByPlanning(id, params);

      if (res?.status === HttpStatusCode.Ok) {
        setMaterials(
          setAllValue(res?.data, [
            "materialsBargeCOMAMA",
            "materialsBargeSEMS",
            "materialsCraneCOMAMA",
            "materialsCraneSEMS",
            "materialsLiftingCOMAMA",
            "materialsLiftingSEMS",
            "materialsMachineCOMAMA",
            "materialsMachineSEMS",
            "materialsTugboatCOMAMA",
            "materialsTugboatSEMS",
          ])
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeTransportType = (value: any) => {
    const newType = value?.target?.value;
    setSelectedTransportType(newType);
  };

  const [selectedLabel, setSelectedLabel] = useState(
    MaterialConstant.MATERIAL_TYPE_OPTIONS.find(
      (opt) => opt.value === selectedTransportType
    )?.label
  );

  const menuProps = {
    items: MaterialConstant.MATERIAL_TYPE_OPTIONS.map((item) => ({
      key: item.value,
      label: item.label,
    })),
    onClick: ({ key }: any) => {
      setSelectedTransportType(key);
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev.toString());
        newParams.set("type", key.toLowerCase());
        return newParams;
      });
    },
  };

  const onAddMaterialItem = (keyName: string) => {
    setMaterials((prev: any) => ({
      ...prev,
      [keyName]: [
        ...prev?.[keyName],
        {
          type: null,
          material: null,
        },
      ],
    }));
  };

  const handleChangeItem = (index: number, keyName: string, value: any) => {
    setMaterials((prev: any) => ({
      ...prev,
      [keyName]: prev?.[keyName]?.map((elem: any, key: number) => {
        if (key !== index) {
          return elem;
        } else {
          return {
            ...elem,
            error: false,
            ...value,
          };
        }
      }),
    }));
  };

  const onDeleteMaterialItem = (keyName: string, key: number) => {
    setMaterials((prev: any) => ({
      ...prev,
      [keyName]: prev?.[keyName].filter(
        (_: any, index: number) => key !== index
      ),
    }));
  };

  const handleSubmit = async (e?: any) => {
    e?.preventDefault();

    let tempMaterials = { ...materials };
    let isHavingError = false;

    allKeys.forEach((item) => {
      tempMaterials[item] = tempMaterials?.[item]?.map((elem: any) => {
        if (!elem?.material) {
          isHavingError = true;
          return { ...elem, error: true };
        }
        return { ...elem, error: false };
      });
    });

    setMaterials(tempMaterials);

    if (isHavingError) {
      return;
    }

    try {
      setIsLoadingSubmit(true);

      const formattedDataToPost = {
        ...(materials?.["@id"]
          ? {
              "@id": materials?.["@id"],
            }
          : {}),
        operationMaterials: getAllValue(tempMaterials, allKeys),
      };

      if (id) {
        const res = await PlanningService.patchMaterialByPlanning(
          id,
          formattedDataToPost
        );
        if (res?.status === HttpStatusCode.Ok) {
          // onClose();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const getAllValue = (
    initObject: any,
    allKeys: Array<string>
  ): Array<PostDataTypeItem> => {
    let allValue: Array<PostDataTypeItem> = [];
    allKeys.forEach((key: string) => {
      if (initObject?.[key] && initObject?.[key]?.length) {
        allValue = [
          ...allValue,
          ...initObject?.[key]
            ?.filter((item: any) => item?.material)
            ?.map((item: any) => ({
              ...(item?.["@id"] && { "@id": item?.["@id"] }),
              ...(item?.quantity && { quantity: item?.quantity?.toString() }),
              material: item?.material?.value,
            })),
        ];
      }
    });
    return allValue;
  };

  const setAllValue = (initObject: any, allKeys: Array<string>) => {
    let allValue = {
      ...initObject,
    };
    allKeys.forEach((key: string) => {
      if (initObject?.[key] && initObject?.[key]?.length) {
        allValue = {
          ...allValue,
          [key]: allValue?.[key]?.map((item: any) => ({
            ...item,
            ...(item?.material?.type
              ? {
                  type: {
                    value: item?.material?.type?.["@id"],
                    label: item?.material?.type?.name,
                  },
                }
              : {}),
            ...(item?.quantity && { quantity: item?.quantity }),

            material: {
              label: item?.material?.reference,
              value: item?.material?.["@id"],
              title: item?.material?.driver || item?.material?.materialUnit || item?.material?.comamaDriverName,
            },
          })),
        };
      }
    });

    return allValue;
  };

  const handleDateFilter = (value: any) => {
    if (value) {
      setFilter((prev: any) => ({
        ...prev,
        teamsCreatedAt: dayjs(value).format("YYYY-MM-DD"),
      }));
    } else {
      setFilter((prev: any) => ({
        ...prev,
        teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
      }));
    }
  };

  return (
    <MaterialRequestContext.Provider
      value={{
        materials,
        selectedMaterials,
        isDisableForm,
        onAddMaterialItem,
        onDeleteMaterialItem,
        handleChangeItem,
      }}
    >
      <div className={style.material_request}>
        <Loader isLoading={isLoading} />

        <div className="d-flex w-100 justify-content-between">
          <div className="w-100">
            <Segmented
              value={selectedTransportType}
              onChange={(e: any) => {
                const newValue = e;
                setSelectedTransportType(newValue);
                setSearchParams((prev) => {
                  const newParams = new URLSearchParams(prev.toString());
                  newParams.set("type", newValue.toLowerCase());
                  return newParams;
                });
              }}
              options={MaterialConstant.MATERIAL_TYPE_OPTIONS}
              // optionType="button"
              // buttonStyle="outline"
              style={{ marginBottom: 16 }}
            />
            {/* <Segmented
              value={selectedTransportType}
              onChange={(e) => {
                const newValue = e.target.value;
                setSelectedTransportType(newValue);
                setSearchParams((prev) => {
                  const newParams = new URLSearchParams(prev.toString());
                  newParams.set("type", newValue.toLowerCase());
                  return newParams;
                });
              }}
              optionType="button"
              buttonStyle="outline"
              style={{ marginBottom: 16 }}
            >
              {MaterialConstant.MATERIAL_TYPE_OPTIONS.map((item) => {
                const isSelected = selectedTransportType === item.value;
                return (
                  <Radio.Button
                    key={item.value}
                    value={item.value}
                    style={{
                      backgroundColor: "white",
                      color: isSelected ? "#1677ff" : "black",
                      borderColor: isSelected ? "#1677ff" : "#d9d9d9",
                    }}
                  >
                    {item.label}
                  </Radio.Button>
                );
              })}
            </Segmented> */}
          </div>

          <div
            className="d-flex w-100 justify-content-center"
            style={{
              height: "30px",
            }}
          >
            <DatePicker
              placeholder=""
              value={dayjs(filter.teamsCreatedAt, "YYYY-MM-DD")}
              format={"DD/MM/YYYY"}
              onChange={handleDateFilter}
            />
          </div>
          <div className="w-100"></div>
        </div>

        <div className="">
          {selectedTransportType ===
          MaterialConstant.TRANSPORT_AND_LIFTING_ID ? (
            <MaterialTransportAndLiftingForm />
          ) : (
            ""
          )}
          {selectedTransportType === MaterialConstant.AREMING_ID ? (
            <MaterialArmingForm />
          ) : (
            ""
          )}
        </div>
        <div className={style.planning__footer}>
          <button
            className={style.planning__footer_button}
            onClick={handleSubmit}
            disabled={isLoadingSubmit || isDisableForm}
            style={{
              cursor: isDisableForm ? "not-allowed" : "pointer",
            }}
          >
            {" "}
            {isLoadingSubmit ? <Spinner /> : "Enregistrer"}
          </button>
        </div>
      </div>
    </MaterialRequestContext.Provider>
  );
};
